var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V4.5C14.9987 3.57215 14.6295 2.68268 13.9734 2.02659C13.3173 1.3705 12.4279 1.00132 11.5 1H1V8H4.2325L6.021 10.683L6.444 13.6415C6.47904 13.8794 6.5982 14.0968 6.77984 14.2543C6.96148 14.4118 7.19358 14.499 7.434 14.5H8.5C8.8977 14.4996 9.279 14.3414 9.56022 14.0602C9.84144 13.779 9.9996 13.3977 10 13V10H13C13.5302 9.99934 14.0386 9.78841 14.4135 9.41348C14.7884 9.03855 14.9993 8.53023 15 8ZM4 7H2V2H4V7ZM14 8C13.9996 8.26509 13.8941 8.51922 13.7067 8.70667C13.5192 8.89412 13.2651 8.9996 13 9H9V13C9 13.1326 8.94732 13.2598 8.85355 13.3536C8.75979 13.4473 8.63261 13.5 8.5 13.5H7.4335L6.9785 10.317L5 7.3485V2H11.5C12.1628 2.00079 12.7982 2.26444 13.2669 2.73311C13.7356 3.20178 13.9992 3.8372 14 4.5V8Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeSelected);
export default __webpack_public_path__ + "static/media/dislikeSelected.ce6a8b5228f47bb6b39750884daaf144.svg";
export { ForwardRef as ReactComponent };